/**
 * German FAQ copy. Mirrors the Dutch master in ../faq-data.ts: same
 * three categories, same eleven questions, same order. Every shipping
 * and returns number is interpolated from the live policy `p`, never
 * written into the copy, and the shipping answers name the country the
 * terms apply to (the policy is resolved for NL and BE only).
 */

import type { FAQPolicyValues } from "../faq-data.ts";
import type { FaqBuilder } from "./index.ts";

const buildFaqsDe: FaqBuilder = (p: FAQPolicyValues, fmt) => {
  const secondaryLine =
    p.secondaryCountryName && p.secondaryFreeAbove
      ? ` Nach Belgien ist der Versand ab €${fmt.eur(p.secondaryFreeAbove)} kostenlos.`
      : "";
  return [
    {
      category: "Produkte & Allergien",
      items: [
        {
          q: "Ich habe eine Allergie, sind Ihre Produkte für mich geeignet?",
          a: "In fast allen Fällen sind unsere Produkte geeignet. Schreiben Sie uns eine E-Mail mit Ihrer konkreten Allergie, dann beraten wir Sie persönlich, welche Produkte für Sie sicher sind. Sie können auch zuerst eine Probe bestellen und das Produkt an einer kleinen Stelle auf der Haut testen.",
        },
        {
          q: "Was bedeutet hypoallergen?",
          a: "Hypoallergen bedeutet, dass die Wahrscheinlichkeit einer allergischen Reaktion äußerst gering ist. Alle Produkte von Unity Cosmetics sind hypoallergen. Wir wählen bewusst Inhaltsstoffe, die möglichst wenig Risiko für Reizungen mit sich bringen.",
        },
        {
          q: "Wie kann ich testen, ob ein Produkt für mich geeignet ist?",
          a: "Wir empfehlen, das Produkt zuerst an einer Stelle in der Ellenbeuge auszuprobieren. Eine Überempfindlichkeit oder allergische Reaktion zeigt sich in der Regel innerhalb von 24 Stunden in Form von Juckreiz, leichter Rötung und manchmal kleinen Pickelchen. Von den meisten Produkten sind Proben erhältlich.",
        },
        {
          q: "Sind Ihre Produkte vegan?",
          a: "Ein großer Teil unseres Sortiments ist vegan. Auf der Produktseite steht bei den Klassifizierungen, ob ein Produkt vegan ist. Alle Produkte sind tierversuchsfrei.",
        },
        {
          q: "Enthalten Ihre Produkte Gluten?",
          a: "Alle unsere Produkte sind glutenfrei. Das steht auch bei den Klassifizierungen auf der Produktseite.",
        },
      ],
    },
    {
      category: "Bestellen & Bezahlen",
      items: [
        {
          q: "Welche Zahlungsmethoden akzeptieren Sie?",
          a: "Wir akzeptieren iDEAL, Visa, Mastercard, PayPal, Klarna (später bezahlen), Bancontact und SEPA-Überweisung.",
        },
        {
          q: "Wann erhalte ich meine Bestellung?",
          a: `Die Lieferzeit beträgt ${fmt.deliveryWindow}. Wir versenden über ${p.carrier} mit Sendungsverfolgung. Sobald Ihr Paket versandt ist, erhalten Sie eine Bestätigungsmail mit Tracking-Code.`,
        },
        {
          q: "Gibt es kostenlosen Versand?",
          a: `Ja, bei Bestellungen ab €${fmt.eur(p.primaryFreeAbove)} ist der Versand innerhalb der Niederlande kostenlos.${secondaryLine}`,
        },
        {
          q: "Kann ich auch Proben bestellen?",
          a: "Ja, von den meisten Produkten sind Proben erhältlich. So können Sie das Produkt zuerst auf Ihrer Haut testen, bevor Sie die volle Größe kaufen.",
        },
      ],
    },
    {
      category: "Rückgabe",
      items: [
        {
          q: "Kann ich ein Produkt zurücksenden?",
          a: `Nach Erhalt Ihrer Bestellung haben Sie ${p.returnWindowDays} Tage Widerrufsrecht. Produkte müssen ungeöffnet und in der Originalverpackung zurückgesendet werden. Die Rücksendekosten gehen zu Ihren Lasten (ca. €${fmt.eur(p.returnCost)}).`,
        },
        {
          q: "Was ist, wenn ich eine allergische Reaktion bekomme?",
          a: "Nehmen Sie sofort Kontakt mit uns auf. Auch wenn die Wahrscheinlichkeit bei unseren Produkten äußerst gering ist, nehmen wir jede Reaktion ernst. Wir helfen Ihnen mit einer passenden Lösung.",
        },
      ],
    },
  ];
};

export default buildFaqsDe;
